<div class="pagoRow valePromo form-group-nocurrency" [formGroup]="codigoClienteForm">
  <div class="tit-form-group">{{ 'CODIGO_CLIENTE' | translate }}</div>
  <div>
    <div class="form-group-nocurrency ">
      <div class="form-group-nocurrency CodigoClienteForm">
        <select formControlName="tipoDocumento" type="33" class="form-control dropdown" id="tipoDocumentoInput"
                [ngClass]="{ 'is-invalid': g.tipoDocumento.invalid && g.tipoDocumento.touched }">
          <option value="">{{ 'TIPO_DOCUMENTO' | translate }}</option>
          <option *ngFor="let option of optionsTipoDoc" [value]="option">{{ option }}</option>
        </select>
        <input
          type="text"
          #codigoCliente
          formControlName="codigoCliente"
          class="form-control dni"
          category="ALFANUMERICO"
          [ngClass]="{ 'is-invalid': g.codigoCliente.invalid && g.codigoCliente.touched, readonly: obtenerDesactivarCodigoCliente(), 'active-form': isSelected(codigoCliente) }"
          [readonly]="obtenerDesactivarCodigoCliente()"
          id="codigoClienteInput"
          (focus)="focusValue($event)"
          placeholder="NIF"
          autocomplete="nope"
          maxlength=50
        />
      </div>
      <input *ngIf="ventanaActualDePago"
             type="button"
             id="codigoClienteBoton"
             class="pagar aceptar"
             formControlName="descuentoCodigoCliente"
             [ngClass]="{ disabled: obtenerDesdeAsociado()}"
             (click)="aplicarCodigoCliente()"
             value="{{ 'APLICAR' | translate }}" />
      <input *ngIf="!ventanaActualDePago"
             type="button"
             id="codigoClienteBoton"
             class="pagar aceptar"
             formControlName="descuentoCodigoCliente"
             (click)="buscarCliente()"
             value="{{ 'BUSCAR' | translate }}" />
    </div>
  </div>
</div>
